{
  "mar": {
    "title": "Medication Administration Record",
    "loading": "Loading MAR...",
    "emptyState": "No active medications for this patient",
    "loadError": "Failed to load medications",
    "retry": "Retry",
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "Shift",
    "dayShiftHeader": "Day Shift (07:00 - 19:00)",
    "nightShiftHeader": "Night Shift (19:00 - 07:00)",
    "newOrder": "New Medication Order",
    "printMar": "Print MAR",
    "prnSection": "PRN Medications",
    "filter": {
      "timeWindow": "Time window",
      "category": "Category",
      "status": "Status",
      "scheduledOnly": "Scheduled only"
    },
    "adminStatus": {
      "scheduled": "Scheduled",
      "dueNow": "Due Now",
      "overdue": "Overdue",
      "administered": "Given",
      "held": "Held",
      "refused": "Refused",
      "missed": "Missed"
    },
    "columns": {
      "medication": "Medication",
      "drug": "Drug",
      "doseRoute": "Dose / Route",
      "schedule": "Schedule",
      "scheduledTime": "Scheduled time",
      "givenTime": "Given time",
      "givenBy": "Given by",
      "status": "Status"
    },
    "actions": {
      "administer": "Administer",
      "hold": "Hold",
      "refuse": "Refuse",
      "skip": "Skip",
      "missed": "Mark missed",
      "edit": "Edit administration",
      "viewHistory": "View history",
      "givePrn": "Give PRN"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "HIGH ALERT",
      "indication": "Indication: {{indication}}",
      "lastGiven": "Last given: {{time}}",
      "lastGivenBy": "Last given: {{time}} by {{user}}"
    },
    "orderBadge": {
      "active": "Active",
      "onHold": "On Hold",
      "discontinued": "Discontinued"
    },
    "legend": "Legend:",
    "summary": {
      "medsGivenToday": "Medications given today: ",
      "ofTotal": "{{given}} of {{total}}",
      "overdueCount_one": "{{count}} overdue",
      "overdueCount_other": "{{count}} overdue",
      "nextDue": "Next due: ",
      "nextDueAt": "{{medName}} at {{time}}"
    },
    "tooltip": {
      "given": "(given {{time}})",
      "pending": "Recording… not yet confirmed by the server"
    },
    "doseModal": {
      "title": "Administer Dose",
      "doseGiven": "Dose given",
      "siteOfAdministration": "Site",
      "comments": "Comments",
      "vitalsCheck": "Pre-administration vitals",
      "doubleCheck": "Two-clinician verification",
      "verifier": "Verifier",
      "confirm": "Confirm administration"
    },
    "administerDialog": {
      "doseLabel": "Dose",
      "routeLabel": "Route",
      "siteLabel": "Site (if applicable)",
      "site": {
        "notApplicable": "Not applicable",
        "leftArm": "Left Arm",
        "rightArm": "Right Arm",
        "leftDeltoid": "Left Deltoid",
        "rightDeltoid": "Right Deltoid",
        "leftGluteal": "Left Gluteal",
        "rightGluteal": "Right Gluteal",
        "leftThigh": "Left Thigh",
        "rightThigh": "Right Thigh",
        "abdomen": "Abdomen"
      },
      "timeAdministered": "Time Administered",
      "administeredDateAria": "Administered date",
      "administeredTimeAria": "Administered time",
      "notesLabel": "Notes",
      "notesPlaceholder": "Optional notes..."
    },
    "prnWarning": {
      "title": "PRN Interval Warning",
      "lastDoseHoursAgo": "Last dose was given {{hours}} hours ago.",
      "minimumInterval": "Minimum interval is {{hours}} hours.",
      "lastAdministered": "Last administered: {{time}}",
      "justificationLabel": "Justification for early administration",
      "justificationRequired": "*",
      "justificationPlaceholder": "Enter clinical justification for administering before minimum interval...",
      "cancel": "Cancel",
      "overrideContinue": "Override and Continue"
    },
    "toast": {
      "administered": "Medication administered",
      "administerError": "Failed to record administration",
      "administerNotImplemented": "MAR administration recording not yet available",
      "held": "Medication held",
      "refused": "Patient refusal recorded",
      "skipped": "Medication skipped",
      "orderNotActive": "This order is no longer active (discontinued, cancelled or completed) and cannot be administered."
    },
    "holdRefuseDialog": {
      "holdTitle": "Hold Medication",
      "refuseTitle": "Refuse Medication",
      "skipTitle": "Skip Medication",
      "scheduledLabel": "Scheduled: {{time}}",
      "holdReasonLabel": "Hold Reason",
      "refusalNotesLabel": "Refusal Notes",
      "skipReasonLabel": "Skip Reason",
      "holdReasonPlaceholder": "Enter reason for hold...",
      "refusalPlaceholder": "Document patient refusal...",
      "skipPlaceholder": "Enter reason for skipping...",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "contextMenu": {
      "hold": "Hold",
      "refuse": "Refuse",
      "skip": "Skip"
    },
    "holdReason": {
      "label": "Hold reason",
      "options": {
        "patientNpo": "Patient NPO",
        "vitalsOutOfRange": "Vitals out of range",
        "patientRefused": "Patient refused",
        "providerOrder": "Provider order to hold",
        "other": "Other"
      }
    },
    "give": {
      "title": "Give · {{medication}} {{dose}}",
      "scheduledLabel": "Scheduled {{time}}",
      "patientLabel": "Patient",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "Patient ID: {{id}}",
      "medicationLabel": "Medication",
      "scanPatientPlaceholder": "Scan the wristband",
      "scanPatientAria": "Scan patient wristband",
      "scanMedicationPlaceholder": "Scan the package barcode",
      "scanMedicationAria": "Scan medication package",
      "patientMismatch": "This wristband is not this patient. Do not administer.",
      "medicationMismatch": "This package is not the ordered medication. Do not administer.",
      "notScannable": "Cannot be scan-verified — no barcode on file for this order",
      "overrideReason": "Reason for giving without a scan",
      "overrideReasonPlaceholder": "e.g. wristband damaged; unbarcoded compounded dose",
      "pharmacyOverride": "Pharmacy has not verified this high-alert medication",
      "pharmacyOverridePlaceholder": "Why can this dose not wait for pharmacy review?",
      "timeLabel": "Time",
      "detailsEdit": "Edit",
      "detailsDone": "Done",
      "confirmLabel": "These match the order and the dose I am holding",
      "cancel": "Cancel",
      "submit": "Give",
      "witness": {
        "banner": "HIGH ALERT — second-nurse witness required",
        "usernameLabel": "Second nurse username",
        "passwordLabel": "Password",
        "verify": "Verify",
        "verifying": "Verifying…",
        "verified": "Witnessed by a second nurse",
        "rejected": "Credentials not recognised.",
        "overrideLabel": "Cannot witness? Give without a second-nurse check — reason",
        "overridePlaceholder": "Why can this dose not wait for an independent double-check?"
      },
      "refusal": {
        "wrongPatient": "Wrong patient — the scanned wristband does not match this order. Do not administer.",
        "wrongMedication": "Wrong medication — the scanned package does not match the ordered drug. Do not administer.",
        "scanRequired": "Scan the wristband and the medication, or give a reason for not scanning.",
        "pharmacyVerificationRequired": "Pharmacy has not verified this order. Await verification, or record why it cannot wait.",
        "doubleCheckRequired": "No second nurse has double-checked this order. Have it witnessed, or record why it cannot wait.",
        "doubleCheckSelf": "You cannot witness your own administration. A second nurse must verify this dose."
      },
      "dispense": {
        "handedOver": "{{quantity}} handed over {{time}}",
        "label": "Pharmacy dispense",
        "none": "No dispense recorded for this order",
        "pending": "Dispense recorded, not yet handed over",
        "prepared": "{{quantity}} prepared {{time}}",
        "unavailable": "Could not check dispensing — the record was not reached"
      }
    }
  },
  "status": {
    "active": "Active",
    "held": "Held",
    "discontinued": "Discontinued",
    "completed": "Completed",
    "refused": "Refused",
    "missed": "Missed",
    "given": "Given"
  },
  "route": {
    "po": "Oral (PO)",
    "iv": "Intravenous (IV)",
    "im": "Intramuscular (IM)",
    "sc": "Subcutaneous (SC)",
    "in": "Intranasal (IN)",
    "pr": "Per Rectum (PR)",
    "sl": "Sublingual (SL)",
    "top": "Topical (TOP)",
    "neb": "Nebulised (NEB)",
    "pv": "Per Vagina (PV)",
    "ng": "Nasogastric (NG)",
    "ophthalmic": "Ophthalmic",
    "transdermal": "Transdermal"
  },
  "__review_route": "Route abbreviation conventions may vary in APAC — verify with local clinical reviewer",
  "frequency": {
    "bid": "Twice daily (BID)",
    "tid": "Three times daily (TID)",
    "qid": "Four times daily (QID)",
    "qd": "Daily (QD)",
    "qhs": "At bedtime (QHS)",
    "prn": "As needed (PRN)",
    "stat": "Immediately (STAT)",
    "continuous": "Continuous"
  },
  "__review_frequency": "Dosing-abbreviation conventions may vary in APAC — verify with local clinical reviewer",
  "formulary": {
    "title": "Medication Formulary",
    "searchPlaceholder": "Search medications by name, generic name, or code...",
    "clearSearch": "Clear search",
    "category": {
      "all": "All",
      "analgesic": "Analgesic",
      "antibiotic": "Antibiotic",
      "antifungal": "Antifungal",
      "antiviral": "Antiviral",
      "cardiac": "Cardiac",
      "endocrine": "Endocrine",
      "gi": "GI",
      "neurological": "Neurological",
      "psychiatric": "Psychiatric",
      "respiratory": "Respiratory",
      "other": "Other"
    },
    "columns": {
      "medication": "Medication",
      "genericName": "Generic Name",
      "form": "Form",
      "strength": "Strength",
      "route": "Route",
      "status": "Status",
      "schedule": "Schedule"
    },
    "highAlertBadge": "High-Alert Medication",
    "highAlertTag": "High Alert",
    "status": {
      "preferred": "Preferred",
      "restricted": "Restricted",
      "nonFormulary": "Non-Formulary"
    },
    "loading": "Loading formulary...",
    "loadError": "Failed to load formulary",
    "empty": "No medications found.",
    "pagination": {
      "showing": "Showing {{from}}-{{to}} of {{total}}",
      "page": "Page {{page}} of {{totalPages}}",
      "previous": "Previous page",
      "next": "Next page"
    },
    "details": {
      "close": "Close details",
      "genericName": "Generic Name",
      "category": "Category",
      "formStrength": "Form / Strength",
      "route": "Route",
      "formularyStatus": "Formulary Status",
      "deaSchedule": "DEA Schedule",
      "indications": "Indications",
      "contraindications": "Contraindications",
      "interactions": "Drug Interactions",
      "sideEffects": "Side Effects",
      "dosageGuidelines": "Dosage Guidelines",
      "specialPopulations": "Special Populations",
      "storage": "Storage"
    },
    "__review_status": "'Non-Formulary' wire value uses a hyphen; resolved via colocated STATUS_KEY → camelCase. Verify clinical reviewer prefers 'Non-Formulary' vs 'Not on Formulary' wording.",
    "__review_category": "Category labels are short English clinical headers (Analgesic, Antibiotic, GI, etc.); some locales keep the English source verbatim for clinician familiarity. Verify with local clinical reviewer.",
    "__review_deaSchedule": "DEA Schedule is US-DEA controlled-substance schedule (II/III/IV/V); APAC sites use local equivalents (e.g. SG: First/Second Schedule; HK: Dangerous Drugs Schedules). Verify acronym/glossing per locale with local pharmacy compliance."
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "Pharmacist Verification Queue",
    "subtitle": "Review and verify pending medication orders",
    "pendingCount": "{{count}} pending",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by medication, patient name, or MRN...",
    "priority": {
      "all": "All Priorities",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "loadError": "Failed to load medication queue",
    "retry": "Retry",
    "empty": {
      "title": "All caught up",
      "description": "No pending medication orders to verify."
    },
    "columns": {
      "patient": "Patient",
      "medication": "Medication",
      "doseRouteFreq": "Dose / Route / Freq",
      "priority": "Priority",
      "orderingProvider": "Ordering Provider",
      "ordered": "Ordered",
      "actions": "Actions"
    },
    "row": {
      "unknown": "Unknown",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "Controlled {{schedule}}",
      "providerFallback": "Provider #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "Verify",
      "verifyTooltip": "Verify this medication order",
      "reject": "Reject",
      "rejectTooltip": "Reject and discontinue",
      "confirmReject": "Confirm",
      "cancelReject": "Cancel",
      "rejectReasonPlaceholder": "Rejection reason..."
    },
    "toast": {
      "verifySuccess": "Medication #{{id}} verified",
      "verifyError": "Failed to verify medication",
      "rejectSuccess": "Medication #{{id}} rejected and discontinued",
      "rejectError": "Failed to reject medication",
      "rejectReasonRequired": "Please provide a reason for rejection",
      "notIndependent": "The prescriber cannot verify their own order.",
      "overrideSuccess": "Order {{id}} advanced without pharmacist verification",
      "overrideError": "Could not record the override",
      "overrideReasonRequired": "An override needs both a reason code and a justification"
    },
    "__review_priority": "STAT / ASAP kept verbatim across all locales per Phase-2 register policy (precedent: orders.priority.values.stat/asap, results.pending.priority). 'Routine' / 'Scheduled' translate. The row priority badge previously uppercased wire values via .toUpperCase() — Tailwind class dropped consistent with Task 4 precedent.",
    "verifyDialog": {
      "title": "Verify medication order",
      "instruction": "Confirm each check you completed. All four are required — a partial review is not a verification.",
      "checks": {
        "allergy": "I reviewed this order against the patient's allergies",
        "interaction": "I reviewed it for drug–drug interactions",
        "duplicateTherapy": "I reviewed it for duplicate therapy",
        "doseRange": "I reviewed the dose for this patient"
      },
      "cancel": "Cancel",
      "confirm": "Verify order"
    },
    "override": {
      "action": "Override",
      "confirm": "Record override",
      "cancel": "Cancel",
      "tooltip": "Proceed without pharmacist verification. Records a reason; does not satisfy the high-alert pharmacy check.",
      "codeLabel": "Override reason code",
      "codePlaceholder": "Select a reason…",
      "justificationLabel": "Override justification",
      "justificationPlaceholder": "Why is this proceeding without pharmacy review?",
      "code": {
        "pharmacyClosed": "Pharmacy closed",
        "urgentClinicalNeed": "Urgent clinical need",
        "pharmacyUnreachable": "Pharmacy unreachable"
      }
    },
    "clarify": {
      "action": "Clarify",
      "tooltip": "Pharmacy encoded this order differently. Settle it before the drug can be given.",
      "heading": "Pharmacy encoded this differently",
      "holding": "(holds the order)",
      "upheld": "Order stands",
      "upheldTooltip": "The original order is correct; dispense as written.",
      "amended": "I have amended it",
      "amendedTooltip": "Record that the order has been changed.",
      "adopt": "Adopt pharmacy's version",
      "adoptTooltip": "Accept the encoded version under a collaborative practice agreement or P&T protocol.",
      "close": "Close",
      "toast": {
        "resolved": "Clarification settled; the order returns for verification",
        "error": "Could not settle the clarification"
      }
    }
  },
  "reconciliation": {
    "title": "Medication Reconciliation",
    "subtitle": "{{patient}} | {{mrn}} | Encounter #{{encounter}}",
    "complete": "Complete Reconciliation",
    "loading": "Loading medications...",
    "column": {
      "home": "Home Medications",
      "inpatient": "Inpatient Medications",
      "discharge": "Discharge Medications"
    },
    "emptyHome": "No home medications found.",
    "emptyInpatient": "No inpatient medications found.",
    "emptyDischarge": "No discharge medications yet. Continue or modify medications from the other columns.",
    "changedFromHome": "Changed from home medication",
    "action": {
      "continue": "Continue",
      "modify": "Modify",
      "discontinue": "Discontinue",
      "discontinueShort": "D/C",
      "newOrder": "New"
    },
    "addToDischarge": "Add to discharge",
    "remove": "Remove",
    "modifyForm": {
      "title": "Modify Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "dosePlaceholder": "e.g., 500mg",
      "routePlaceholder": "e.g., PO",
      "frequencyPlaceholder": "e.g., BID",
      "cancel": "Cancel",
      "save": "Save"
    },
    "back": "Back",
    "toast": {
      "completed": "Medication reconciliation completed",
      "completeError": "Failed to complete reconciliation",
      "atLeastOne": "Please reconcile at least one medication before completing"
    },
    "__review_action": "Reconciliation action wire values use 'new' (singular) for new-order; the plan seed names this 'newOrder' so the colocated ACTION_KEY map routes 'new' → 'newOrder'. 'D/C' is the short-form Discontinue button label and stays as the international clinical abbreviation across locales (parallels healthcare-acronym register). Plan seed listed a 'hold' action which this page does not use — omitted here, can be added if the page later grows a hold workflow."
  },
  "components": {
    "dosingCalculator": {
      "title": "Dosing Calculator",
      "weightLabel": "Patient Weight (kg) *",
      "heightLabel": "Height (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "e.g. 70",
      "heightPlaceholder": "e.g. 170",
      "gfrPlaceholder": "Optional",
      "bsaLabel": "Calculated BSA (Mosteller):",
      "calculate": "Calculate Dose",
      "error": "Failed to calculate dose. The backend may not have dosing data for this medication.",
      "renalAdjustment": "Renal Adjustment:",
      "originalDose": "Original dose:",
      "min": "Min:",
      "max": "Max:",
      "recommended": "Recommended: {{dose}} {{unit}}",
      "apply": "Apply Dose",
      "method": {
        "weightBased": "Weight-Based",
        "bsaBased": "BSA-Based",
        "flat": "Flat Dose",
        "renalAdjusted": "Renal-Adjusted"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry."
    }
  },
  "prescribe": {
    "title": "Prescribe Medication",
    "submit": "Prescribe",
    "navButton": "Prescribe",
    "noActiveEncounter": "A prescription must be attached to an active encounter. Open or admit this patient to an encounter before prescribing.",
    "fields": {
      "medication": "Medication",
      "dose": "Dose",
      "doseUnit": "Unit",
      "route": "Route",
      "frequency": "Frequency",
      "frequencyDescription": "Frequency description",
      "duration": "Duration",
      "durationUnit": "Duration unit",
      "totalDoses": "Total doses",
      "isPrn": "PRN (as needed)",
      "prnIndication": "PRN indication",
      "administrationInstructions": "Administration instructions",
      "patientInstructions": "Patient instructions",
      "quantityDispensed": "Quantity dispensed",
      "refillsAuthorized": "Refills authorized",
      "allowSubstitution": "Allow generic substitution",
      "pharmacyNotes": "Pharmacy notes",
      "indication": "Indication",
      "clinicalIndication": "Clinical indication",
      "priority": "Priority"
    },
    "sections": {
      "drug": "Drug",
      "dosing": "Dosing",
      "durationPrn": "Duration & PRN",
      "instructions": "Instructions",
      "dispensing": "Dispensing",
      "clinical": "Clinical"
    },
    "doseUnitPlaceholder": "e.g. mg",
    "drugSearch": {
      "placeholder": "Search the formulary…",
      "noResults": "No formulary matches",
      "clear": "Clear selection",
      "catalogRequired": "Select a drug from the formulary to prescribe",
      "catalogOnly": "Only formulary drugs can be prescribed, so every safety check can run.",
      "controlledBadge": "Controlled — Schedule {{schedule}}",
      "controlledTag": "Controlled",
      "highAlertBadge": "High-Alert Medication",
      "highAlertTag": "High Alert",
      "contraindications": "Contraindications: {{text}}"
    },
    "route": {
      "oral": "Oral (PO)",
      "iv": "Intravenous (IV)",
      "subcutaneous": "Subcutaneous (SC)",
      "intramuscular": "Intramuscular (IM)",
      "topical": "Topical",
      "inhalation": "Inhalation",
      "rectal": "Rectal (PR)",
      "ophthalmic": "Ophthalmic",
      "transdermal": "Transdermal"
    },
    "frequency": {
      "QD": "Once daily (QD)",
      "BID": "Twice daily (BID)",
      "TID": "Three times daily (TID)",
      "QID": "Four times daily (QID)",
      "Q4H": "Every 4 hours (Q4H)",
      "Q6H": "Every 6 hours (Q6H)",
      "Q8H": "Every 8 hours (Q8H)",
      "Q12H": "Every 12 hours (Q12H)",
      "QHS": "At bedtime (QHS)",
      "PRN": "As needed (PRN)",
      "STAT": "Immediately (STAT)"
    },
    "durationUnit": {
      "days": "Days",
      "weeks": "Weeks",
      "months": "Months",
      "doses": "Doses"
    },
    "priority": {
      "routine": "Routine",
      "asap": "ASAP",
      "stat": "STAT"
    },
    "validation": {
      "prnIndicationRequired": "A PRN indication is required for an as-needed order"
    },
    "contextBar": {
      "ariaLabel": "Prescribing context",
      "allergies": {
        "label": "Allergies",
        "none": "No known allergies",
        "severe": "Severe"
      },
      "weight": {
        "label": "Weight",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "Not recorded"
      },
      "renal": {
        "label": "Renal function",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "Renal function unknown",
        "source": {
          "reported": "reported",
          "computed": "computed",
          "unknown": "unknown"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "Medication prescribed",
      "error": "Could not place the order. Please try again.",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "Prescribed with safety advisories",
      "continue": "Continue"
    },
    "safetyReview": {
      "title": "Safety Review Required",
      "proceed": "Override & Prescribe",
      "cancel": "Cancel",
      "reasonPrompt": "Select an override reason…",
      "freeTextLabel": "Additional detail",
      "freeTextPlaceholder": "Add clinical context (optional)",
      "hardBlockNote": "This block cannot be overridden.",
      "cannotOverride": "This prescription cannot proceed — one or more blocks cannot be overridden.",
      "blockKind": {
        "cds_contraindication": "Contraindication",
        "cds_unavailable": "Safety screening unavailable",
        "renal_contraindication": "Renal contraindication",
        "dose_range": "Dose outside recommended range",
        "pregnancy_contraindication": "Pregnancy risk",
        "unknown": "Additional safety block"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "History reviewed manually",
        "NO_KNOWN_RISK_THIS_PATIENT": "No known risk for this patient",
        "URGENT_CLINICAL_NEED": "Urgent clinical need",
        "OTHER": "Other (specify)",
        "BENEFIT_OUTWEIGHS_RISK": "Benefit outweighs risk",
        "DOSE_REDUCED_PER_PROTOCOL": "Dose reduced per protocol",
        "EGFR_NOT_REPRESENTATIVE": "eGFR not representative",
        "SPECIALIST_ADVICE": "Specialist advice",
        "PATIENT_TOLERANT": "Patient tolerant of this dose",
        "SPECIALIST_PROTOCOL": "Per specialist protocol",
        "TITRATING_TO_EFFECT": "Titrating to effect",
        "RANGE_NOT_APPLICABLE": "Range not applicable",
        "STATUS_CONFIRMED_NEGATIVE": "Pregnancy status confirmed negative",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "Benefit outweighs fetal risk",
        "CONTRACEPTION_CONFIRMED": "Effective contraception confirmed",
        "PREGNANCY_BEING_TERMINATED": "Pregnancy being terminated"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
